import {
  customScrollMinimal,
  TableCell,
  TableHeader,
  typographyV2,
} from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledTableHeader = styled(TableHeader)`
  position: sticky;
  left: 0;
  top: 0;
  border-bottom: 1px solid var(--border-default);
  z-index: var(--z-index-header-cell);
`;

export const TableWrapper = styled.div<{
  $isLoading: boolean;
}>`
  ${customScrollMinimal};
  overflow-y: auto;
  flex: 1 1 0px;
  width: 100%;
  height: 100%;
  z-index: 1;

  ${({ $isLoading }) =>
    $isLoading
      ? css`
          table tr:last-child td {
            border-bottom: none;
          }
        `
      : css`
          table tr:nth-last-child(-n + 2) td {
            border-bottom: none;
          }
        `}
  table tr:last-child td {
    cursor: default;

    &:hover {
      background-color: var(--background-default);
    }
  }
`;

export const StyledTableCell = styled(TableCell)`
  white-space: normal;
`;

export const FooterRow = styled(TableCell)`
  padding: 20px 0 0 0;
`;

export const RankWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`;

export const ProductWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 300px;
`;

export const DescriptionWrapper = styled.div`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;
